import { render } from "./FileForm.vue?vue&type=template&id=50d0f1f8&ts=true"
import script from "./FileForm.vue?vue&type=script&lang=ts"
export * from "./FileForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__